export default __webpack_public_path__ + "static/mit-680a356c8aafe7f15975a184685585e6.png";